import { useState, useEffect } from 'react'
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'

import { useForm, Controller } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import { useNavigate, useSearchParams } from 'react-router-dom'

import apiUrl from '../../../../configs/constant'
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto'

interface FormInputs {
  vendor_id: any
  vendor_name: any
  tgl: any
  keterangan: any
  is_langsung: number
  nomor_penerimaan: any
  accakun_id: any
  sisa_saldo: any
}

const AddAPReceipt = () => {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const navigate = useNavigate()

  const [searchParams] = useSearchParams();
  const pbsupplier_id = searchParams.get('pbsupplier_id');

  const [openVendor, setOpenVendor] = useState(false)
  const [listVendor, setListVendor] = useState<any[]>([])
  const [listAkun, setListAkun] = useState<any[]>([])
  const [mode, setMode] = useState<any>(null)

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useForm<FormInputs>({
    defaultValues: {
      tgl: moment().format('YYYY-MM-DD'),
      is_langsung: 0
    }
  })

  // ================= GET CUSTOMER =================
  const getVendor = () => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-vendor', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data
        const supplier = data.find((item: any) => item.id === Number(pbsupplier_id))
        if (supplier) {
          pilihVendor(supplier)
        }
        setListVendor(data)
      }
    })
  }

  // ================= GET AKUN =================
  const getAkun = () => {
    axios.get(apiUrl.apiUrl + '/acc/arr/get-akun', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        setListAkun(res.data.data)
      }
    })
  }

  // ================= GET NOMOR PENERIMAAN =================
  const getNomorPenerimaan = (id: any) => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-list-nomor-penerimaan', {
      params: { id },
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data;
        if (data.length > 0) {
          setValue('nomor_penerimaan', data[0].id)
          setValue('sisa_saldo', data[0].sisa_saldo)
        } else {
          setValue('nomor_penerimaan', '')
          setValue('sisa_saldo', '')
          // set Mode ke Pelunasan Langsung
          setMode(1)
          setValue('is_langsung', 1)
          // Tampilkan alert bahwa customer tidak memiliki penerimaan, jadi langsung pelunasan
          Swal.fire({
            title: 'Info',
            text: 'Customer ini tidak memiliki penerimaan, jadi langsung pelunasan',
            icon: 'info'
          })
        }
      }
    })
  }

  // ================= SUBMIT =================
  const onSubmit = (data: any) => {
    Swal.fire({
      title: 'Konfirmasi',
      text: 'Simpan data ini?',
      icon: 'question',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(apiUrl.apiUrl + '/acc/app/add', data, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
          if (res.data.success) {
            const id = res.data.data
            Swal.fire('Success', res.data.message, 'success')
            navigate('/acc/app/detail/' + id)
          }
        })
      }
    })
  }

  useEffect(() => {
    getVendor()
    getAkun()
  }, [])

  useEffect(() => {
    if (mode === 0) {
      setValue('is_langsung', 0)
    } else {
      setValue('is_langsung', 1)
    }
  }, [mode])


  const pilihVendor = (item: any) => {
    setValue('vendor_id', item.id)
    setValue('vendor_name', item.nama)
    getNomorPenerimaan(item.id)
    setOpenVendor(false)
  }

  // ================= UI =================
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant='h5' sx={{ textAlign: 'center', mb: 3 }}>
              Buat AP Payment
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>

                {/* CUSTOMER */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <Controller
                      name="vendor_name"
                      control={control}
                      defaultValue=""   // ?? WAJIB
                      rules={{ required: true }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Vendor"
                          onClick={() => setOpenVendor(true)}
                          InputProps={{ readOnly: true }}
                          error={Boolean(errors.vendor_name)}
                          InputLabelProps={{ shrink: true }}   // ?? Tambahkan ini
                        />
                      )}
                    />
                    {errors.vendor_name && (
                      <FormHelperText error>Vendor wajib diisi</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* TANGGAL */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name='tgl'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type='date'
                        label='Tanggal'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                {/* RADIO */}
                <Grid item xs={12}>
                  <RadioGroup
                    row
                    value={mode}
                    onChange={(e) => setMode(Number(e.target.value))}
                  >
                    <FormControlLabel value={0} control={<Radio disabled={getValues('is_langsung') == 1 ? true : false} />} label='Penerimaan Customer' />
                    <FormControlLabel value={1} control={<Radio disabled={getValues('is_langsung') == 0 ? true : false} />} label='Pelunasan Langsung' />
                  </RadioGroup>
                </Grid>

                {/* NOMOR PENERIMAAN */}
                {mode === 0 && (
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name='nomor_penerimaan'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label='Down Payment'
                          fullWidth
                          InputProps={{ readOnly: true }}
                        />
                      )}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Akun Pembayaran</InputLabel>
                    <Controller
                      name='accakun_id'
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Select {...field} label='Akun Pembayaran'>
                          {listAkun.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                              {item.kode} - {item.nama}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>

                {mode === 0 && (
                  <Grid item xs={12} sm={12}>
                    <Controller
                      name='sisa_saldo'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label='Sisa Saldo'
                          fullWidth
                          InputProps={{ readOnly: true }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {/* KETERANGAN */}
                <Grid item xs={12}>
                  <Controller
                    name='keterangan'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label='Keterangan'
                        multiline
                        rows={3}
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                  <Button variant='contained' type='submit'>
                    SIMPAN
                  </Button>
                </Grid>

              </Grid>
            </form>
          </CardContent>
        </Card>
      </Grid>

      {/* POPUP VENDOR */}
      <Dialog open={openVendor} maxWidth='lg' fullWidth>
        <DialogTitle>Pilih Vendor</DialogTitle>
        <DialogContent>
          <MsiDatagrid
            array={listVendor}
            rowClick={(e: any) => {
              const item = e.data
              pilihVendor(item)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenVendor(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}

export default AddAPReceipt
